<template>
  <div class="d-flex justify-content-between data-item-custom-route">
    <div class="font-medium font-weight-400">
      {{ $t('duration') }}
    </div>
    <div class="font-medium font-weight-400">
      {{ totalDuration.hours }} {{ $t('shortened_hours') }} {{ totalDuration.minutes }} {{ $t('shortened_minutes') }}
    </div>

  </div>

  <div class=" d-flex justify-content-between data-item-custom-route">
    <div class="font-medium font-weight-400">
      {{ $t('distance') }}
    </div>
    <div class="font-medium font-weight-40">
      {{ totalDistance }} km.
    </div>
  </div>

  <div class=" d-flex justify-content-between align-items-baseline data-item-custom-route">
    <div class="font-medium font-weight-700">
      {{ $t('price') }}
    </div>
    <div class="font-medium font-weight-700">
      {{ price }} &euro;
    </div>
  </div>
</template>

<script lang="ts">
import './customRoutePriceWrapper.scss';
import {defineComponent} from "vue";
export default defineComponent({
  name: 'CustomRoutePriceWrapperComponent',
  props: {
    totalDistance: {
      type: Number
    },
    totalDuration: {
      type: Object
    },
    price: {
      type: Number
    },
  }

})
</script>

<style scoped>

</style>